var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCamcorderDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.78571 7.03683L0.553571 2.80469C0.5 2.91183 0.5 3.07254 0.5 3.17969V10.6797C0.5 11.5904 1.19643 12.2868 2.10714 12.2868H4.67857L4.19643 12.8761C3.82143 13.3583 3.71429 14.0011 3.98214 14.5904C4.25 15.1261 4.83929 15.5011 5.42857 15.5011H10.5179C11.1607 15.5011 11.6964 15.1261 11.9643 14.5904C12.0179 14.5368 12.0179 14.4297 12.0714 14.3761L7.89286 10.144C6.17857 10.0904 4.83929 8.75112 4.78571 7.03683Z",
    fill: "#CCCFD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 10.6786V3.17857C15.5 2.26786 14.8036 1.57143 13.8929 1.57143H2.32143L1.41071 0.660714C1.19643 0.446429 0.875 0.446429 0.660714 0.660714C0.446429 0.875 0.446429 1.19643 0.660714 1.41071L14.5893 15.3393C14.6964 15.4464 14.8571 15.5 14.9643 15.5C15.0714 15.5 15.2321 15.4464 15.3393 15.3393C15.5536 15.125 15.5536 14.8036 15.3393 14.5893L13.0357 12.2857H13.8929C14.8036 12.2857 15.5 11.5893 15.5 10.6786ZM8.58929 7.83929C8.85714 7.625 9.07143 7.30357 9.07143 6.92857C9.07143 6.33929 8.58929 5.85714 8 5.85714C7.625 5.85714 7.30357 6.07143 7.08929 6.33929L5.58929 4.83929C6.17857 4.14286 7.03571 3.71429 8 3.71429C9.76786 3.71429 11.2143 5.16071 11.2143 6.92857C11.2143 7.89286 10.7857 8.75 10.0893 9.33929L8.58929 7.83929Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamcorderDisable);
export default __webpack_public_path__ + "static/media/icon-camcorder-disable.c8413223a3d9a6dab55662591284e0c3.svg";
export { ForwardRef as ReactComponent };